import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app-layout"
}
const _hoisted_2 = { class: "app-layout__content" }

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import BottomNavigation from '@/components/layout/BottomNavigation.vue';
import BaseToast from '@/components/ui/BaseToast.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const useAppLayout = computed(() => route.meta.layout === 'app');

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      (useAppLayout.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_router_view)
            ]),
            _createVNode(BottomNavigation)
          ]))
        : (_openBlock(), _createBlock(_component_router_view, { key: 1 })),
      _createVNode(BaseToast)
    ]),
    _: 1
  }))
}
}

})